/* istanbul ignore file */
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { KHFileInfo } from '.';
import { FileTypes } from '../shared/enums';

export class ShapefileInfo {
    selectedShapefiles: KHFileInfo[] = [];
    shapefile: KHFileInfo;
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: [FileTypes.Zip]
    };
    acceptedFileTypes: string[] = ['.' + FileTypes.Zip];
    isFetchingGeoJsonFile = false;
    showErrorMessage = false;
    guideMessage = 'Accepts: ZIP file containing at least the .shp, .shx, .dbf, and .prj file components of the shapefile.';
    errorMessage = 'Accepts: ZIP file containing at least the .shp, .shx, .dbf, and .prj file components of the shapefile.';
}
